document.addEventListener('DOMContentLoaded', () => {
  const copyButtons = document.querySelectorAll('.hlf-po-card__right[data-action="COPY"], .hlf-po-card__right[data-action="copy"]');

  copyButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const code = button.getAttribute('data-copy-code');
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        const textElement = button.querySelector('.hlf-po-action-text');
        const originalText = textElement.textContent;
        
        textElement.textContent = 'COPIED!';
        
        setTimeout(() => {
          textElement.textContent = originalText;
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy code: ', err);
      });
    });
  });
});
